module.exports = "data:image/gif;base64,R0lGODlhEgASAPAAAP8AAP///ywAAAAAEgASAAACIoSPqcvtG54JtFoZsd1Ygs0xWfaJYJiQanNW3kF61EvXbwEAOw=="